import React from "react";
import LoadingIndicator from "@/components/LoadingIndicator/LoadingIndicator";
import styles from "@/components/LanguageModelArtifact/style.module.css";
const EvaluatorStatus = ({ status }) => {
    if (status === "notEvaluated") {
        return React.createElement("div", { className: styles.fineTuningItem }, "Not Evaluated");
    }
    if (status === "pending") {
        return (React.createElement("div", { className: styles.fineTuningItem },
            React.createElement("div", { style: { display: "flex", alignItems: "center" } },
                React.createElement(LoadingIndicator, { style: { marginLeft: "-14px", scale: "0.5", marginRight: "0px" } }),
                "Evaluating")));
    }
    if (status === "evaluated") {
        return React.createElement("div", { className: styles.fineTuningItem }, "\u2705 Evaluated");
    }
    return null;
};
export default EvaluatorStatus;
